import classNames from 'classnames';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import style from './index.module.scss';

const Cover = ({ children, imageUrl, tall = false }) => (
  <>
    <Wrapper>
      <div
        className={classNames('bg-center', style.component, {
          [style['component--tall']]: tall,
        })}
        style={{
          backgroundImage: `url(${imageUrl})`,
          aspectRatio: 1600 / 600,
          maxWidth: '100%',
          width: '100%',
          height: 'auto',
          backgroundSize: 'contain',
          margin: 'auto',
        }}
      />
    </Wrapper>
    <Box mt={{ _: 10, m: '60px' }}>{children}</Box>
  </>
);

Cover.propTypes = {
  children: PropTypes.object.isRequired,
  imageUrl: PropTypes.string,
  tall: PropTypes.bool,
};

export default Cover;

const Wrapper = styled(Box)`
  height: 0;
  overflow: visible;
`;
